import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { FcInfo } from "react-icons/fc";
import { useIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";

type EquipmentSearchFiltersType = {
    carPlate?: string;
    setCarPlate?: (newValue: string) => void;
    serialNumber: string;
    setSerialNumber: (newValue: string) => void;
    clientVatNumber: string;
    setClientVatNumber: (newValue: string) => void;
    freeSearch: string;
    setFreeSearch: (newValue: string) => void;
    onButtonClick: () => void;
    onRemoveFiltersClick: () => void;
};

export function EquipmentSearchFilters({
    carPlate,
    setCarPlate,
    serialNumber,
    setSerialNumber,
    clientVatNumber,
    setClientVatNumber,
    freeSearch,
    setFreeSearch,
    onButtonClick,
    onRemoveFiltersClick,
}: EquipmentSearchFiltersType) {
    const intl = useIntl();

    const [isButtonsDisabled, setIsButtonsDisabled] = useState(true);

    useEffect(() => {
        if (carPlate === "" && serialNumber === "" && clientVatNumber === "" && freeSearch === "" && isButtonsDisabled === false) {
            setIsButtonsDisabled(true);
        }

        if ((carPlate !== "" || serialNumber !== "" || clientVatNumber !== "" || freeSearch !== "") && isButtonsDisabled === true) {
            setIsButtonsDisabled(false);
        }
    }, [carPlate, serialNumber, clientVatNumber, freeSearch, isButtonsDisabled]);

    return (
        <>
            <Row>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <InputComponent
                        xl={2}
                        lg={3}
                        md={4}
                        sm={6}
                        xs={9}
                        style={{ width: "100%" }}
                        type={"text"}
                        onEnter={onButtonClick}
                        value={freeSearch}
                        label={"Pesquisa Livre"}
                        readOnly={false}
                        onChange={(t: string) => setFreeSearch(t)}
                    />
                    <Tooltip
                        title={<div style={{ fontSize: "12px", fontWeight: "bold" }}> Código Cliente, Nome Cliente, NIF Cliente. Código Equipamento, Nome Equipamento, Matrícula do Equipamento, Número de Série Equipamento, Marca Equipamento, Modelo Equipamento. </div>}
                        disableFocusListener
                        enterTouchDelay={0}
                        enterNextDelay={100}
                        enterDelay={100}
                        placement={"right"}
                        style={{ cursor: "pointer", marginLeft: "10px", marginTop: "20px" }}
                    >
                        <b>
                            <FcInfo className='notesIcon' fontSize={20} />
                        </b>
                    </Tooltip>
                </div>
            </Row>

            <Row>
                <Col xl={3} lg={3} md={3} sm={12} xs={12} style={{ marginTop: "1em", display: "inline-flex", gap: "1rem" }}>
                    <ButtonComponent
                        text={intl.formatMessage({ id: "Common.Buttons.Search" })}
                        onClick={onButtonClick}
                        disabled={isButtonsDisabled}
                    />
                    <ButtonComponent
                        text={intl.formatMessage({ id: "Common.Buttons.RemoveFilters" })}
                        onClick={onRemoveFiltersClick}
                        disabled={isButtonsDisabled}
                    />
                </Col>
            </Row>
        </>
    );
}
